<template>
  <v-app>
    <v-container fluid class="pa-2">
      <v-form @submit.prevent="submitForm">
        <v-row>
          <!-- SALES CONTACT INFORMATION -->
          <v-col cols="12" md="12">
            <v-expansion-panels v-model="panel" multiple>
              <v-expansion-panel>
                <v-expansion-panel-title class="panel-header" color="blue-grey-lighten-4">
                  Transmittal Information
                </v-expansion-panel-title>

                <v-expansion-panel-text class="px-2">
                  <v-row dense class="mt-3">

                    <v-col cols="12" md="3">
                      <v-select
                        label="From*"
                        v-model="from_transmittal_id"
                        :items="userList"
                        :item-title="item => `${item.full_name} (${item.email}) (${item.branch.name})`"
                        item-value="id"
                        density="compact"
                        variant="outlined"
                        clearable
                      />
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-select
                        label="To*"
                        v-model="to_transmittal_id"
                        :items="userList"
                        :item-title="item => `${item.full_name} (${item.email}) (${item.branch.name})`"
                        item-value="id"
                        density="compact"
                        variant="outlined"
                        clearable
                      />
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-date-input
                        label="Date*"
                        v-model="transmittal_date"
                        density="compact"
                        variant="outlined"
                        prepend-icon=""
                        prepend-inner-icon="mdi-calendar"
                        clearable
                      ></v-date-input>
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-text-field
                        label="Contract No*"
                        v-model="contact_no"
                        density="compact"
                        variant="outlined"
                        autocomplete="off"
                      />
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-text-field
                        label="Trans. No*"
                        v-model="transmittal_no"
                        density="compact"
                        variant="outlined"
                        autocomplete="off"
                      />
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-text-field
                        label="Component*"
                        v-model="component_no"
                        density="compact"
                        variant="outlined"
                      />
                    </v-col>

                    <v-col cols="12" md="8">
                      <v-text-field
                        label="Subject*"
                        v-model="subject"
                        density="compact"
                        variant="outlined"
                      />
                    </v-col>

                     <v-col cols="12" md="3">
                      <v-select
                        label="Folder*"
                        v-model="folder_id"
                        :items="folderList"
                        item-title="name"
                        item-value="id"
                        density="compact"
                        variant="outlined"
                        clearable
                      />
                    </v-col>

                    <v-col cols="12" md="8">
                      <v-combobox
                        v-model="cc"
                        density="compact"
                        variant="outlined"
                        label="Cc"
                        multiple
                        chips
                        closable-chips
                      />
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-select
                        label="Copy Type*"
                        v-model="copy_type"
                        :items="copyTypes"
                        item-title="display_text"
                        item-value="value"
                        density="compact"
                        variant="outlined"
                        clearable
                      />
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-select
                        label="Submitted For*"
                        v-model="submitted_for"
                        :items="submittedTypes"
                        item-title="display_text"
                        item-value="value"
                        density="compact"
                        variant="outlined"
                        clearable
                      />
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-select
                        label="Via*"
                        v-model="via"
                        :items="viaItems"
                        item-title="display_text"
                        item-value="value"
                        density="compact"
                        variant="outlined"
                        clearable
                      />
                    </v-col>

                    <v-col cols="12" md="12">
                      <v-textarea
                        label="Comment"
                        v-model="comment"
                        rows="3"
                        density="compact"
                        variant="outlined"
                      />
                    </v-col>
                  </v-row>
                </v-expansion-panel-text>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>

          <!-- DETAILS BREAKDOWN -->
          <v-col cols="12" md="12">
            <v-expansion-panels v-model="panel1" multiple>
              <v-expansion-panel>
                <v-expansion-panel-title class="panel-header" color="blue-grey-lighten-4">
                  Documents Detail
                </v-expansion-panel-title>

                <v-expansion-panel-text>
                  <v-card>
                    <v-card-text class="px-2"  style="overflow-y: auto; white-space: nowrap;">
                      <table class="dep-table order-table mt-4 custome-table">
                        <thead>
                          <tr>
                            <th class="table-header-cel" v-for="col in headers" :key="col.value">{{ col.text }}</th>
                            <th class="table-header-cel">Action</th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr v-for="(row, rowIndex) in tableData" :key="row.id" :class="{ 'error-row': tableErrors[rowIndex] }">
                            <td v-for="(col, colIndex) in headers" :key="col.value">
                              <v-text-field
                                style="min-width:150px;"
                                v-if="!['cargo_receive_date', 'etd_date', 'date'].includes(col.value) && col.value !== 'currency_id'"
                                class="breakdown-input"
                                v-model="row[col.value]"
                                :type="['quantity', 'unit_price', 'total_amount'].includes(col.value) ? 'number' : 'text'"
                                dense
                                hide-details
                                variant="outlined"
                                @keydown.enter.prevent="focusNextCell(rowIndex, colIndex)"
                                @keydown.tab.prevent="focusNextCell(rowIndex, colIndex)"
                                @input="calculateTotal(rowIndex)"
                              />

                              <v-date-input
                                v-if="['cargo_receive_date', 'etd_date', 'date'].includes(col.value)"
                                style="height:30px !important; min-width:150px;"
                                class="breakdown-input"
                                v-model="row[col.value]"
                                variant="outlined"
                                density="compact"
                                prepend-icon=""
                                @keydown.enter.prevent="focusNextCell(rowIndex, colIndex)"
                                @keydown.tab.prevent="focusNextCell(rowIndex, colIndex)"
                                clearable
                              />

                              <v-select
                                style="min-width:150px;"
                                v-if="col.value === 'currency_id'"
                                class="breakdown-input"
                                v-model="row[col.value]"
                                :items="currencyList"
                                item-title="name"
                                item-value="id"
                                dense
                                hide-details
                                variant="outlined"
                                @keydown.enter.prevent="focusNextCell(rowIndex, colIndex)"
                                @keydown.tab.prevent="focusNextCell(rowIndex, colIndex)"
                              />
                            </td>
                            <td style="width:65px;">
                              <v-btn v-if="(rowIndex != tableData.length - 1) || (tableData.length > 1)" icon variant="tonal" size="small" color="primary" class="pa-1 breakdown-input" @click="removeRow(rowIndex)">
                                <v-icon color="red">mdi-close</v-icon>
                              </v-btn>

                              <v-btn v-if="rowIndex == tableData.length - 1" variant="tonal" icon size="small" color="primary" class="breakdown-input" @click="addRow">
                                <v-icon color="blue">mdi-plus</v-icon>
                              </v-btn>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </v-card-text>

                    <v-card-actions class="justify-end">
                      <v-btn class="bg-grey-darken-1 me-2" @click="submitForm(0)">Draft</v-btn>
                      <v-btn class="bg-primary" @click="submitForm(1)">
                        {{ isEdit ? 'Update' : 'Save' }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-expansion-panel-text>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
  </v-app>
</template>

<script setup>
import formattedDate from "@/plugins/dateFormatter";
import { ref, reactive, nextTick, onMounted, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { toast } from "vue3-toastify";
import { useStore } from "vuex";
import * as yup from "yup";

const store = useStore();
const route = useRoute();
const router = useRouter();
const transmittalId = route.query.id;

const headers = [
  { text: "Copies", value: "copies" },
  { text: "Drawing/Doc No.", value: "doc_no" },
  { text: "Rev.", value: "rev" },
  { text: "Date", value: "date" },
  { text: "Other", value: "other" },
  { text: "Description", value: "description" },
];

const copyTypes = [
  {value: 'hard-copy', display_text: 'Hard Copy (HC)'},
  {value: 'soft-copy', display_text: 'Soft Copy (SC)'}
]

const submittedTypes = [
  {value: 'approval', display_text: 'Approval'},
  {value: 'field-use', display_text: 'Field Use'},
  {value: 'checking', display_text: 'Checking'},
  {value: 'others', display_text: 'Others'},
  {value: 'final-approval', display_text: 'Final Approval'},
  {value: 'pricing', display_text: 'Pricing'},
  {value: 'field-measurement', display_text: 'Field Measurements'},
  {value: 'preliminary-only', display_text: 'Preliminary Only'},
  {value: 'reproduction', display_text: 'Reproduction'},
  {value: 'information', display_text: 'Information'},
  {value: 'fabrication', display_text: 'Fabrication'},
  {value: 'your-use', display_text: 'Your Use'},
]

const viaItems = [
  {value: 'ups-courier', display_text: 'UPS/Courier'},
  {value: 'mdsc-transport', display_text: 'MDSC Transport'},
  {value: 'hand-carry', display_text: 'Hand Carry'},
  {value: 'email', display_text: 'Email'},
]

const panel = ref([0]);
const panel1 = ref([0]);
const isEdit = ref(false);

// Master fields
const from_transmittal_id = ref(null);
const to_transmittal_id = ref(null);
const transmittal_date = ref(null);
const contact_no = ref("");
const transmittal_no = ref("");
const component_no = ref("");
const subject = ref("");
const folder_id = ref(null);
const cc = ref("");
const copy_type = ref(null);
const submitted_for = ref(null);
const via = ref(null);
const comment = ref("");

// Lists
const userList = computed(() => store.getters.getUsersList || []);
const folderList = computed(() => store.getters.getCmsFoldersList || []);

const tableData = reactive([]);
const errors = reactive({});
const tableErrors = reactive({});

function addRow() {
  const newId = tableData.length ? tableData[tableData.length - 1].id + 1 : 1;
  const row = {
    id: newId,
    copies: "",
    doc_no: "",
    rev: "",
    // when creating a new row, default the date column to today
    date: formattedDate(new Date()),
    other: "",
    description: ""
  };
  tableData.push(row);
  nextTick(() => focusCell(tableData.length - 1, 0));
}

function removeRow(index) {
  if (tableData.length > 1) {
    tableData.splice(index, 1);
  }
}

function calculateTotal(rowIndex) {
  const row = tableData[rowIndex];
  if (row.quantity && row.unit_price) {
    row.total_amount = parseFloat(row.quantity) * parseFloat(row.unit_price);
  } else {
    row.total_amount = 0;
  }
}

function focusNextCell(rowIndex, colIndex) {
  const totalRows = tableData.length;
  const totalCols = headers.length;

  let nextRow = rowIndex;
  let nextCol = colIndex + 1;

  if (nextCol >= totalCols) {
    nextCol = 0;
    nextRow++;
    if (nextRow >= totalRows) {
      addRow();
      nextRow = totalRows;
    }
  }

  focusCell(nextRow, nextCol);
}

function focusCell(rowIndex, colIndex) {
  nextTick(() => {
    const table = document.querySelector("table");
    const row = table?.rows[rowIndex + 1];
    if (row) {
      const cell = row.cells[colIndex]?.querySelector("input, select");
      if (cell) cell.focus();
    }
  });
}

const detailSchema = yup.object({
  // po: yup.string().required("PO required"),
  // style_no: yup.string().required("Style no required"),
  // quantity: yup.number().typeError("Quantity must be number").required().positive(),
  // unit_price: yup.number().typeError("Unit price must be number").required().min(0),
  // total_amount: yup.number().required(),
  // currency_id: yup.number().required("Currency required"),
});

const schema = yup.object({
  from_transmittal_id: yup.number().required("From required"),
  to_transmittal_id: yup.number().required("To required"),
  transmittal_date: yup.date().required("Transmittal date required"),
  contact_no: yup.string().required("Contract no required"),
  transmittal_no: yup.string().required("Transmittal no required"),
  component_no: yup.string().required("Component no required"),
  subject: yup.string().required("Subject required"),
  folder_id: yup.number().required("Folder required"),
  copy_type: yup.string().required("Copy type required"),
  submitted_for: yup.string().required("Submitted for required"),
  via: yup.string().required("Via required"),
  comment: yup.string().required("Comment required"),
  // details: yup.array().of(detailSchema).min(1),
});

async function getInitialData() {
  try {

    store.commit("SET_LOADING", { color: "primary" });
    // Load customer list for buyers
    if (store.getters.getUsersList.length === 0) {
      await store.dispatch("getUsersList", {branch: ''});
    }

    // Load LC bank list for beneficiary and buyer banks
    if (store.getters.getCmsFoldersList.length === 0) {
      await store.dispatch("getCmsFoldersList", {});
    }

    if (transmittalId) {
      isEdit.value = true;
      // Load existing data
      await store.dispatch("getCmsTransmittalById", transmittalId).then((response) => {
        if (response.data.success) {
          const data = response.data.data;
          from_transmittal_id.value = data.from_transmittal_id;
          to_transmittal_id.value = data.to_transmittal_id;
          transmittal_date.value = data.transmittal_date;
          contact_no.value = data.contact_no;
          transmittal_no.value = data.transmittal_no;
          component_no.value = data.component_no;
          subject.value = data.subject;
          cc.value = JSON.parse(data.cc);
          copy_type.value = data.copy_type;
          submitted_for.value = data.submitted_for;
          via.value = data.via;
          comment.value = data.comment;
          // Load details
          if (data.details && data.details.length > 0) {
            tableData.splice(0, tableData.length);
            data.details.forEach((detail) => {
              tableData.push({
                id: detail.id,
                copies: detail.copies,
                doc_no: detail.doc_no,
                rev: detail.rev,
                date: detail.date,
                other: detail.other,
                description: detail.description,
              });
            });
          }
        }
      });
    } else {
      addRow();
      transmittal_date.value = new Date();
    }
    store.commit("UNSET_LOADING");
  } catch (error) {
    console.error("Error loading data:", error);
    store.commit("UNSET_LOADING");
  }
}

async function submitForm(status) {
  const payload = {
    from_transmittal_id: from_transmittal_id.value,
    to_transmittal_id: to_transmittal_id.value,
    transmittal_date: formattedDate(transmittal_date.value),
    contact_no: contact_no.value,
    transmittal_no: transmittal_no.value,
    component_no: component_no.value,
    subject: subject.value,
    cc: cc.value,
    copy_type: copy_type.value,
    submitted_for: submitted_for.value,
    via: via.value,
    comment: comment.value,
    folder_id: folder_id.value,
    status,
    details: tableData.map(row => ({
      id: row.id,
      copies: row.copies,
      doc_no: row.doc_no,
      rev: row.rev,
      date: formattedDate(row.date),
      other: row.other,
      description: row.description,
    })),
  };

  try {
    if (isEdit.value) {
      try {
        await store.dispatch("updateCmsTransmittal", { id: transmittalId, data: payload });
        toast.success("Updated Successfully");
      } catch (error) {
        toast.error(error.response?.data?.message || "Update failed");
        throw error;
      }
    } else {
      await store.dispatch("saveCmsTransmittal", { formData: payload });
      toast.success("Save Successfully");
    }
    router.push({ name: "cms-transmittal-list" });
  } catch (err) {
      console.log(err)
  }
}

onMounted(getInitialData);
</script>

<style>
.panel-header {
  background: #eceff1;
  font-weight: 600;
}

.breakdown-input .v-field {
  min-height: 32px !important;
  height: 32px !important;
  border: none !important;
  border-radius: 0px !important;
}

.breakdown-input .v-field .v-field__input {
  min-height: 32px !important;
  height: 32px !important;
  padding: 2 !important;
  font-size: 12px;
}

.breakdown-input input {
  min-height: 32px !important;
  height: 32px !important;
  max-height: 32px !important;
}

.custome-table {
  width: 100% !important;
  border-collapse: collapse;
}

.custome-table th,
.custome-table td {
  border: 1px solid #c0c0c0;
  text-align: left;
}

.custome-table th {
  background-color: #eceff1;
  font-weight: 600;
}

.table-header-cel {
  text-align: center !important;
  height: 30px;
  font-size: 12px;
}

.v-btn--icon {
  height: 30px !important;
  width: 30px !important;
}

.error-row {
  background: #fff3f3;
}
</style>

